export default {
  apiUrl: 'https://api.srcert.ru/index.php/'

}
